import { TIMELINE_FOCUS_ITEM_QUERY_PARAM } from '@bariendo/lib/constants';
import { MedplumClient } from '@medplum/core';

export type CallActionPayload = {
  call?: {
    callSid?: string;
    reference?: { reference?: string } | string;
  };
};

export type ServiceWorkerMessage =
  | { type: 'CALL_ACTION'; action?: string; payload?: CallActionPayload }
  | {
      type: 'NOTIFICATION_SHOWN' | 'NOTIFICATION_CLICKED' | 'NOTIFICATION_CLOSED' | 'NOTIFICATION_ERROR';
      data?: Record<string, unknown>;
    }
  | { type: string };

export async function handleNotificationDetailsAction(
  medplum: MedplumClient,
  navigate: (to: string) => void,
  payload: CallActionPayload
): Promise<void> {
  const refVal = payload.call?.reference;
  const refStr = typeof refVal === 'string' ? refVal : refVal?.reference;
  if (refStr && refStr.startsWith('Communication/')) {
    const commId = refStr.split('/')[1] ?? '';
    try {
      const comm = await medplum.readResource('Communication', commId);
      const patientRef = comm.subject?.reference;
      if (patientRef && patientRef.startsWith('Patient/')) {
        const patientId = patientRef.split('/')[1] ?? '';
        const url = `/Patient/${encodeURIComponent(patientId)}/timeline?${TIMELINE_FOCUS_ITEM_QUERY_PARAM}=${encodeURIComponent(refStr)}`;
        navigate(url);
        return;
      }
    } catch {
      // fall through to fallback
    }
  }
  const sid = payload.call?.callSid;
  const fallbackUrl = sid ? `/Phone?callSid=${encodeURIComponent(sid)}` : '/Phone';
  navigate(fallbackUrl);
}

export async function handleCallActionEvent(
  medplum: MedplumClient,
  navigate: (to: string) => void,
  message: MessageEvent<ServiceWorkerMessage>
): Promise<void> {
  if (message.data.type !== 'CALL_ACTION') return;
  const callAction = message.data as { type: 'CALL_ACTION'; action?: string; payload?: CallActionPayload };
  const action = callAction.action;
  if (action === 'details') {
    await handleNotificationDetailsAction(medplum, navigate, (callAction.payload ?? {}) as CallActionPayload);
  }
  // Other actions (accept/reject/call-back) are handled by feature-specific listeners (e.g., GlobalPhoneControls)
}
